var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.coLoader
    ? _c(
        "v-layout",
        {
          staticClass: "ma-3 reception-detail-general-info",
          attrs: { column: "" }
        },
        [
          _c(
            "v-layout",
            { staticClass: "mb-2", attrs: { row: "" } },
            [
              _c("v-flex", { attrs: { xs2: "" } }, [
                _c("span", { staticClass: " primary--text" }, [
                  _vm._v(_vm._s(_vm.$t(_vm.lblSetting.receptionDeclarant)))
                ])
              ]),
              _vm._v(" "),
              _c("v-flex", { attrs: { xs8: "" } }, [
                _c("span", { staticClass: "sub-title--text primary--text" }, [
                  _vm._v(_vm._s(_vm.declarantName))
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.reception.participants, function(p, i) {
            return p.relation_type !== "creator"
              ? _c(
                  "v-layout",
                  { key: p.id, staticClass: "mb-2", attrs: { row: "" } },
                  [
                    _c("v-flex", { attrs: { xs2: "" } }, [
                      i === 0
                        ? _c("span", { staticClass: " primary--text" }, [
                            _vm._v(
                              _vm._s(_vm.$t(_vm.lblSetting.receptionCustomer))
                            )
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("v-flex", { attrs: { xs8: "" } }, [
                      _c(
                        "span",
                        { staticClass: "sub-title--text primary--text" },
                        [_vm._v(_vm._s(_vm.getEntityName(p.entity)))]
                      )
                    ])
                  ],
                  1
                )
              : _vm._e()
          }),
          _vm._v(" "),
          _c(
            "v-layout",
            { staticClass: "mb-2", attrs: { row: "" } },
            [
              _c("v-flex", { attrs: { xs2: "" } }, [
                _c("span", { staticClass: " primary--text" }, [
                  _vm._v(_vm._s(_vm.$t(_vm.lblSetting.receptionBlock)))
                ])
              ]),
              _vm._v(" "),
              _c("v-flex", { attrs: { xs8: "" } }, [
                _c("span", { staticClass: "sub-title--text primary--text" }, [
                  _vm._v(_vm._s(_vm.blockName))
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm.$route.path.includes("reception")
            ? _c(
                "v-layout",
                { staticClass: "mb-2", attrs: { row: "" } },
                [
                  _c("v-flex", { attrs: { xs2: "" } }, [
                    _c("span", {
                      staticClass: " primary--text",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t(_vm.lblSetting.receptionApartment)
                        )
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { xs8: "" } }, [
                    _c(
                      "span",
                      { staticClass: "sub-title--text primary--text" },
                      [_vm._v(_vm._s(_vm.apartmentNumber))]
                    )
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.$route.path.includes("vehicle-check")
            ? _c(
                "v-layout",
                { staticClass: "mb-2", attrs: { row: "" } },
                [
                  _c("v-flex", { attrs: { xs2: "" } }, [
                    _c("span", { staticClass: " primary--text" }, [
                      _vm._v("Véhicule")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { xs8: "" } }, [
                    _c(
                      "span",
                      { staticClass: "sub-title--text primary--text" },
                      [_vm._v(_vm._s(_vm.vehicle))]
                    )
                  ])
                ],
                1
              )
            : _vm._e()
        ],
        2
      )
    : _c(
        "div",
        { staticClass: "mt-3" },
        _vm._l(4, function(n) {
          return _c("reception-details-loader", {
            key: n,
            attrs: { "is-general-info": "" }
          })
        }),
        1
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66cdf9ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66cdf9ba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/mh-reception/components/mh-reception-detail-general-info/template.html
// module id = null
// module chunks = 